<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 180px;" type="text" v-model="formInline.PhoneNo" :placeholder="$tt('手机号码')">
				<span slot="prepend">{{$tt('手机号码')}}</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 200px;" type="text" v-model="formInline.MemberName" :placeholder="$tt('会员名称')">
				<span slot="prepend">{{$tt('会员名称')}}</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 200px;" type="text" v-model="formInline.CardNo" :placeholder="$tt('卡号/VIN')">
				<span slot="prepend">{{$tt('卡号/VIN')}}</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem :label="$tt('交易类型')" :label-width="70" prop="trackName">
			<Select :placeholder="$tt('交易类型')" style="width: 120px;" v-model="formInline.TransactionType">
				<Option :value='0'>{{$tt('全部')}}</Option>
				<Option :value='1'>{{$tt('充值')}}</Option>
				<Option :value='2'>{{$tt('退款')}}</Option>
				<Option :value='3'>{{$tt('消费')}}</Option>
				<Option :value='4'>{{$tt('赠送')}}</Option>
				<Option :value='11'>{{$tt('即时支付充值')}}</Option>
				<Option :value='12'>{{$tt('即时支付消费')}}</Option>
				<Option :value='13'>{{$tt('即时支付退款')}}</Option>
			</Select>
		</FormItem>
		<!-- <FormItem :label="$tt('开始时间')" :label-width='100'>
			<DatePicker style="width: 120px;" type="date" :placeholder="$tt('开始时间')" v-model="formInline.TimeBegin">
			</DatePicker>
		</FormItem> -->
		<!-- <FormItem :label="$tt('结束时间')" :label-width='100'>
			<DatePicker style="width: 120px;" type="date" :placeholder="$tt('结束时间')" v-model="formInline.TimeEnd">
			</DatePicker>
		</FormItem> -->
		<FormItem :label="$tt('选择时间')" :label-width='70'>
			<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
				v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('exportFile')" v-if="hasWidgets('export')">{{$tt('导出文件')}}</Button>
		</FormItem>
	</Form>
</template>

<script>
	import dateFormat from '../../../../../public/js/comm.js';
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					MemberId: '',
					MemberName: '',
					CardNo: '',
					TransactionType: 0,
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					Source: 99
				}
			};
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			}
		},
	}
</script>

<style>
</style>
